// src/components/About.js
import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <h2>Our Story</h2>
      <p>
        Founded in 2023, The Flour Pot started as a small passion project in a home kitchen.
        We believe in the magic of traditional baking methods, using only the finest, locally-sourced
        ingredients. Every loaf, pastry, and cake is crafted with care, patience, and a dash of love.
      </p>
    </section>
  );
};

export default About;